import { Link, type LinkProps } from '@ctw/shared/components/link';
import type { TelemetryUserInteraction } from '@ctw/shared/context/telemetry/user-interactions';
import { tw } from '@ctw/shared/utils/tailwind';
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface DocumentViewerControlLinkProps {
  label: string;
  href: string;
  icon: IconDefinition;
  target: LinkProps['target'];
  testId: string;
  telemetryInteractionName: TelemetryUserInteraction;
}

export const DocumentViewerControlLink = ({
  label,
  target,
  href,
  icon,
  testId,
  telemetryInteractionName,
}: DocumentViewerControlLinkProps) => (
  <Link
    dataTestId={testId}
    href={href}
    ariaLabel={label}
    target={target}
    telemetryInteractionName={telemetryInteractionName}
    className={tw`flex items-center justify-center rounded-full bg-content-main p-2 hover:bg-content-subtle/25 active:bg-content-subtle/25`}
  >
    <FontAwesomeIcon className={tw`h-5 w-5 text-white opacity-50`} icon={icon} />
  </Link>
);
